/**
 * Developer sandbox pages are discovered from the filesystem, so adding or
 * removing a `TestN.jsx` file needs no route bookkeeping.
 */
const context = require.context('./pages/test', false, /^\.\/Test(\d+)\.jsx$/);

export const testPages = context
  .keys()
  .map((key) => ({
    number: Number(key.match(/Test(\d+)\.jsx$/)[1]),
    Component: context(key).default,
  }))
  .sort((a, b) => a.number - b.number);
